import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { Observable } from 'rxjs';
import { ListOrganizationInvoiceRequestDto } from '../dto/list-organization-invoice.request.dto';
import { ListOrganizationInvoiceResponseDto } from '../dto/organization-invoice.response.dto';

export abstract class ListOrganizationInvoiceRepository {
    abstract list(
        request: ListOrganizationInvoiceRequestDto,
    ): Observable<ApiResponse<PageableResponse<ListOrganizationInvoiceResponseDto>>>;
}